export default __webpack_public_path__ + "static/media/t2.fb069760.jpeg";